import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { Router } from '@angular/router';

import { AuthenticationService } from '../_services';
import { tap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(
        private authService: AuthenticationService,
        private router: Router, private toasterService: ToastrService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (req.url.search('/login') === -1) {
            if (this.authService.isAuthenticated()) {
                req = req.clone({
                    setHeaders: {
                        Authorization: `Bearer ${this.authService.getIdentity().token}`
                    }
                });
            }
        } else {
            if (this.authService.isAuthenticated()) {
                this.router.navigate(['']);
            }
        }
        return next.handle(req).pipe(
            tap(
                (event: HttpEvent<any>) => {
                    if (event instanceof HttpResponse) {

                    }
                },
                (error: any) => {
                    if (error instanceof HttpErrorResponse) {
                        if (error.status === 401) {
                            // this.toasterService.error('Usuário não autorizado!');
                            this.router.navigate(['/login']);

                        }
                        // if (error.status === 404) {
                        //     this.toasterService.error('Usuário não encontrado.');
                        //     this.router.navigate(['/login']);

                        // }
                    }
                }
            )
        );
    }
}
